import React, { useEffect, useMemo, useRef, useState } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

/* ================== Axios base ================== */
Axios.defaults.baseURL = "https://backend.sansfrontieres-design.com";
Axios.defaults.withCredentials = false;
Axios.defaults.headers.common["X-Login-User"] = getMyWorkId();

/* ========= Compat helpers: lee usuario de session/local ========= */
function getMyWorkId() {
  try {
    const raw =
      sessionStorage.getItem("loggedWorker") ||
      localStorage.getItem("loggedWorker");
    if (raw) return String((JSON.parse(raw).workid || "")).trim();
  } catch {}
  return "";
}

function getLogged() {
  try {
    const raw =
      sessionStorage.getItem("loggedWorker") ||
      localStorage.getItem("loggedWorker");
    if (raw) {
      const u = JSON.parse(raw);
      const name = u?.workid || u?.worknombre || u?.workmail || "";
      return { user: u, display: String(name || "").trim() };
    }
  } catch {}
  const legacy =
    localStorage.getItem("loggedUser") || sessionStorage.getItem("loggedUser");
  if (legacy) return { user: { workid: legacy }, display: String(legacy) };
  return { user: null, display: "" };
}
function clearLogged() {
  try {
    sessionStorage.removeItem("loggedWorker");
    localStorage.removeItem("loggedWorker");
    sessionStorage.removeItem("loggedUser");
    localStorage.removeItem("loggedUser");
  } catch {}
}

/* ================== Helpers HTTP ================== */
const postJSON = (url, payload) =>
  Axios.post(url, payload, { headers: { "Content-Type": "application/json" } });

// Write-helper: igual a postJSON, pero añade __no_history para bloquear el historial en backend
const postWriteJSON = (url, payload) =>
  Axios.post(url, { ...(payload || {}), __no_history: 1 }, { headers: { "Content-Type": "application/json" } });


/* ================== Helpers de fecha ================== */
function nowSql() {
  // Siempre hora de Lima, Perú (America/Lima) sin depender del lugar donde se abra la web
  try {
    // sv-SE => "YYYY-MM-DD HH:mm:ss"
    return new Date().toLocaleString("sv-SE", { timeZone: "America/Lima" });
  } catch {
    // Fallback: Lima = UTC-5 (sin DST). Formato: YYYY-MM-DD HH:mm:ss
    const lima = new Date(Date.now() - 5 * 60 * 60 * 1000);
    const pad = (n) => String(n).padStart(2, "0");
    const yyyy = lima.getUTCFullYear();
    const mm = pad(lima.getUTCMonth() + 1);
    const dd = pad(lima.getUTCDate());
    const hh = pad(lima.getUTCHours());
    const mi = pad(lima.getUTCMinutes());
    const ss = pad(lima.getUTCSeconds());
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  }
}
function formatDateTime(value) {
  if (!value) return "";
  const dt = new Date(value);
  if (isNaN(dt)) {
    const m = String(value).match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2}))?$/
    );
    if (!m) return String(value);
    const [, Y, M, D, h = "00", i = "00", s = "00"] = m;
    const dt2 = new Date(+Y, +M - 1, +D, +h, +i, +s);
    if (isNaN(dt2)) return String(value);
    return dt2.toLocaleString();
  }
  return dt.toLocaleString();
}

/* ============== Utils export ============== */
function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}


/* ==== QC Alerts (Ready for QC → bell in GridPage) ==== */
function trackedProjectCode(jobpro) {
  const s = String(jobpro || "");
  const m = s.match(/project[\s\-_]?(\d{1,2})/i);
  if (!m) return null;
  const code = m[1].padStart(2, "0");
  return `project-${code}`.toLowerCase();
}
const TRACKED_SET = new Set([
  "project-02","project-03","project-05","project-06","project-07",
  "project-08","project-09","project-10","project-11","project-12"
]);
// Sesiones que SÍ pueden disparar correo (DrafterGridPage)
const ALLOWED_LOGIN_SET = new Set([
  "project-02","project-03","project-05","project-06","project-07",
  "project-08","project-09","project-10","project-11","project-12"
]);


// Enviar SMS al pasar a Ready for QC (usa backend PHP)
async function sendReadySms(jobid, jobpro, jobuser){
  try{
    await Axios.post("/notify_ready_qc.php", { jobid, jobpro, jobuser });
  }catch(e){ /* silencio */ }
}

async function bumpQcAlert(jobid, jobpro, jobuser) {
  try {
    const key = 'qcAlerts';
// Gate: SOLO si la sesión logueada es Project-02/03/05/06/08
const sessionCode = trackedProjectCode(getMyWorkId() || (getLogged()?.display || "")) || "";
if (!sessionCode || !ALLOWED_LOGIN_SET.has(String(sessionCode).toLowerCase())) {
  console.log('[QC] session not allowed', { sessionCode });
  return;
}

    const code = trackedProjectCode(jobpro) || sessionCode;
    console.log('[QC] bump candidate', {jobid, jobpro, code});
    if (!code || !TRACKED_SET.has(code)) { console.log('[QC] not tracked', {jobpro}); return; }
    let arr = [];
    try { arr = JSON.parse(localStorage.getItem(key) || '[]'); } catch {}
    if (!Array.isArray(arr)) arr = [];
    const id = String(jobid || '');
    const exists = arr.some(x => (typeof x === 'string' ? x : x?.id) === id);
    if (!exists) {
      const item = { id, project: jobpro || code, time: Date.now() };
      arr.push(item);
      localStorage.setItem(key, JSON.stringify(arr));
      try { setTimeout(() => { try { localStorage.setItem(key, JSON.stringify(arr)); window.dispatchEvent(new StorageEvent('storage', { key, newValue: JSON.stringify(arr) })); } catch(e){} }, 0); } catch(e){}
      try { window.dispatchEvent(new StorageEvent('storage', { key, newValue: JSON.stringify(arr) })); } catch {}
      // Dispara SMS (best-effort)
      try { await sendReadySms(jobid, jobpro || code, jobuser); } catch(e){}
    }
  } catch {}
}


/* =================================================================== */

// Hr Extras: normalize only this field; existing numeric columns keep their behavior.
function normalizeExtraHours(value) {
  const raw = String(value ?? "").trim();
  if (raw === "") return "0";
  if (!/^(?:[0-9]+(?:[.,][0-9]+)?|[.,][0-9]+)$/.test(raw)) {
    throw new Error("Ingresa solo números no negativos. Usa punto (.) o coma (,) como separador decimal.");
  }
  const [whole, fraction = ""] = raw.replace(",", ".").split(".");
  const integer = whole.replace(/^0+/, "") || "0";
  const decimal = fraction.replace(/0+$/, "");
  return integer + (decimal ? "." + decimal : "");
}

// Display two decimal places without changing the stored value.
function formatExtraHours(value) {
  if (value === null || value === undefined || String(value).trim() === "") return "";
  try {
    const [whole, fraction = ""] = normalizeExtraHours(value).split(".");
    return whole + "." + fraction.padEnd(2, "0");
  } catch {
    return String(value);
  }
}

export default function DrafterGridPage() {
  const navigate = useNavigate();

  const DISABLE_GRID_HEADERS = true; // headers look same but locked

  const [records, setRecords] = useState([]);

  // Vista: 'all' = dos grids; 'live' = solo grid 1; 'archived' = solo grid 2
  const [viewMode, setViewMode] = useState("all");

  const [loggedUser, setLoggedUser] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [favoriteRows, setFavoriteRows] = useState([]);
  const [isCreating, setIsCreating] = useState(false);

  const [toasts, setToasts] = useState([]);
  const pushToast = (msg, variant = "success") => {
  if (variant === "success") return;
  const id = Date.now() + Math.random();
  setToasts((t) => [...t, { id, msg, variant }]);
  setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3000);
};

  const statusOptions = [
    
    "Assigned",
    "In Process",
    "In Hold",
    "Correction",
    "Job Ready",        
  ];
  const statusOptionsClean = statusOptions.filter(
    (s) => !["invoicing", "billed", "not assigned", "archived", ].includes(String(s).trim().toLowerCase())
  );
  const userOptions = [
    "Marco",
    "Naara",
    "Pilar",
    "Alessandra",
    "Elizet",
    "Nelson",
    "Ibet",
  ];
  const typeOptions = [
    "Coax Asbuilt",
    "Coax Asb Revert Split",
    "Coax Asb Revert N+0",
    "Coax Design",
    "Coax Bentley",
    "Coax Bentley Asb",
    "Coax Bentley Des",
    "Fiber Bentley Asb",
    "Fiber Bentley Des",
    "Route",
    "Route FTTP",
    "Fiber FTTP",
    "Fiber Design BAU",
    "Fiber Asbuilt BAU",
    "Fiber Iris",
    "Iris Split Fiber Design",
    "Iris Split Coax Design",
    "Iris Split Fiber Asbuilt",
    "Iris Split Coax Asbuilt",
    "Bentley Split Fiber Design",
    "Bentley Split Coax Design",
    "Bentley Split Fiber Asbuilt",
    "Bentley Split Coax Asbuilt",
    "Iris-Splits",
    "Other Tasks",
  ];

  // Project options = SOLO el usuario logueado
  const projectOptions = useMemo(() => {
    const me = getMyWorkId() || loggedUser;
    return me ? [me] : [];
  }, [loggedUser]);

  const [filters, setFilters] = useState({
    jobid: "",
    status: "",
    user: "",
    type: "",
    project: "",
    notes: "",
    proname: "",
    proport: "",
    ou: "",
    lob: "",
    comty: "",
    routeaerial: "",
    routeug: "",
    coaxae: "",
    coaxug: "",
    asbae: "",
    asbug: "",
    lode: "",
    hc: "",
  });

  const [editingCell, setEditingCell] = useState(null); // { id, field }
  const [editValue, setEditValue] = useState("");

  // Evitar commits duplicados por onBlur + Enter
  const committingRef = useRef(false);
  // Evitar dobles INSERT cuando el usuario edita varias celdas muy rápido
  const creatingRef = useRef(new Set());
  const pendingUpdatesRef = useRef(new Map());

  // ====== Estados del segundo grid ======
  const [filters2, setFilters2] = useState({
    jobid: "",
    status: "",
    user: "",
    type: "",
    project: "",
    notes: "",
    proname: "",
    proport: "",
    ou: "",
    lob: "",
    comty: "",
    routeaerial: "",
    routeug: "",
    coaxae: "",
    coaxug: "",
    asbae: "",
    asbug: "",
    lode: "",
    hc: "",
  });
  const [favoriteRows2, setFavoriteRows2] = useState([]);

  const normalize = (v) =>
    (v ?? "")
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "");

  // limpieza fuerte para comparar IDs
  const clean = (v) => (v ?? "").toString().toLowerCase().replace(/[^a-z0-9]/g, "");
  const toId = (v) => (v === null || v === undefined ? "" : String(v));
  const isTempId = (val) => {
    if (!val) return false;
    const s = String(val).trim().toLowerCase();
    return /^jobid\s*nuevo-\d+$/.test(s);
  };
  const tempIndexFromId = (val) => {
    if (!val) return 0;
    const m = String(val).trim().toLowerCase().match(/^jobid\s*nuevo-(\d+)$/);
    return m ? parseInt(m[1], 10) || 0 : 0;
  };
  const nextTempId = () => {
    const max = records.reduce(
      (acc, r) => Math.max(acc, tempIndexFromId(r?.jobid)),
      0
    );
    return `JobID nuevo-${max + 1}`;
  };
  const isPersisted = (r) => {
    if (!r) return false;
    if (r._localNew) return false; // fila creada localmente aún no persistida
    return !!String(r?.jobdatesub || "").trim();
  };

  const fetchRecords = async () => {
    try {
      const { data } = await Axios.get("/get_projects.php?include_extra_hours=1", { withCredentials: false });
      if (data?.status === "success") {
        const my = clean(getMyWorkId());
        const all = Array.isArray(data.data) ? data.data : [];
        const onlyMine = all.filter(r => {
          const jp = clean(r?.jobpro);
          const jpn = clean(r?.jobproname);
          const jpp = clean(r?.jobproport);
          return jp === my || jpn === my || jpp === my;
        });
        setRecords((curr) => {
          const order = new Map((curr || []).map((r, i) => [String(r?.jobid ?? ""), i]));
          const next = onlyMine.slice().sort((a, b) => {
            const ia = order.get(String(a?.jobid ?? ""));
            const ib = order.get(String(b?.jobid ?? ""));
            if (ia === undefined && ib === undefined) return 0; // nuevos: respeta orden del server
            if (ia === undefined) return 1;  // nuevos al final
            if (ib === undefined) return -1;
            return ia - ib;                  // conserva el orden visible
          });
          return next;
        });
        console.log('FILTER', { total: all.length, mine: onlyMine.length, my });
      } else {
        pushToast("Error al cargar proyectos", "info");
      }
    } catch (err) {
      console.error("Error al cargar proyectos:", err);
      pushToast("Guardado local (sin conexión).", "info");
    }
  };

  useEffect(() => {
    const info = getLogged();
    if (!info.user) {
      navigate("/", { replace: true });
      return;
    }
    setLoggedUser(info.display || "");

    const key = normalize(info.display || info.user?.workid || "anon");
    try {
      setFavoriteRows(JSON.parse(localStorage.getItem(`favorites:${key}`)) ?? []);
      setSelectedRows(JSON.parse(localStorage.getItem(`selected:${key}`)) ?? []);
      setFavoriteRows2(JSON.parse(localStorage.getItem(`favorites2:${key}`)) ?? []);
    } catch {}

    fetchRecords();
  }, [navigate]);
  // Auto-refresh cada 30s (solo cuando la pestaña está visible)
  useEffect(() => {
    let timer = null;
    const tick = () => { try { fetchRecords(); } catch {} };
    const onVis = () => {
      if (!document.hidden) {
        tick();
        if (timer) clearInterval(timer);
        timer = setInterval(tick, 30000);
      } else {
        if (timer) { clearInterval(timer); timer = null; }
      }
    };
    document.addEventListener("visibilitychange", onVis);
    onVis();
    return () => { document.removeEventListener("visibilitychange", onVis); if (timer) clearInterval(timer); };
  }, []);


  useEffect(() => {
    if (!loggedUser) return;
    const key = normalize(loggedUser);
    localStorage.setItem(`favorites:${key}`, JSON.stringify(favoriteRows));
  }, [favoriteRows, loggedUser]);
  useEffect(() => {
    if (!loggedUser) return;
    const key = normalize(loggedUser);
    localStorage.setItem(`selected:${key}`, JSON.stringify(selectedRows));
  }, [selectedRows, loggedUser]);

  useEffect(() => {
    if (!loggedUser) return;
    const key = normalize(loggedUser);
    localStorage.setItem(`favorites2:${key}`, JSON.stringify(favoriteRows2));
  }, [favoriteRows2, loggedUser]);

  const handleCheckboxChange = (e, jobId) => {
    const id = toId(jobId);
    setSelectedRows((prev) =>
      e.target.checked ? Array.from(new Set([...prev, id])) : prev.filter((x) => x !== id)
    );
  };
  const toggleFavorite = (jobId) => {
    const id = toId(jobId);
    setFavoriteRows((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };
  const toggleFavorite2 = (jobId) => {
    const id = toId(jobId);
    setFavoriteRows2((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredRecords = useMemo(() => {
    const matchText = (value, needle) =>
      !needle || normalize(value).includes(normalize(needle));
    const matchEq = (value, needle) =>
      !needle || normalize(value) === normalize(needle);

    return (records || []).filter((r) => {
      const f = filters;
      if (String(r?.jobsta ?? "").trim().toLowerCase() === "ready for qc")
        return false;
      if (String(r?.jobsta ?? "").trim().toLowerCase() === "job ready")
        return false;
      const js = String(r?.jobsta ?? "").trim().toLowerCase();
      // Grid 1: NO mostrar estados de facturación/cierre
      if (
        js === "invoicing" ||
        js === "billed" ||
        js === "billing" ||
        js === "payed" ||
        js === "pre-archived" ||
        js === "not assigned" ||
        js === "archived"
      )
        return false;
      if (!matchText(r?.jobid, f.jobid)) return false;
      if (!matchEq(r?.jobsta, f.status)) return false;
      if (!matchEq(r?.jobuser, f.user)) return false;
      if (!matchEq(r?.jobti, f.type)) return false;
      if (!matchText(r?.jobpro, f.project)) return false;
      if (!matchText(r?.jobnotes, f.notes)) return false;

      if (!matchText(r?.jobproname, f.proname)) return false;
      if (!matchText(r?.jobproport, f.proport)) return false;
      if (!matchText(r?.jobou, f.ou)) return false;
      if (!matchText(r?.joblob, f.lob)) return false;
      if (!matchText(r?.jobcomty, f.comty)) return false;
      if (!matchText(r?.jobrouteaerial, f.routeaerial)) return false;
      if (!matchText(r?.jobrouteug, f.routeug)) return false;
      if (!matchText(r?.jobcoaxae, f.coaxae)) return false;
      if (!matchText(r?.jobcoaxug, f.coaxug)) return false;
      if (!matchText(r?.jobasbae, f.asbae)) return false;
      if (!matchText(r?.jobasbug, f.asbug)) return false;
      if (!matchText(r?.joblode, f.lode)) return false;
      if (!matchText(r?.jobhc, f.hc)) return false;
      return true;
    });
  }, [records, filters]);
  // --- Sorting for Grid 1 (Status, User, Type, EP Status, Project) ---
  const [sortKey1, setSortKey1] = useState(null); // 'jobsta' | 'jobuser' | 'jobti' | 'jobclo' | 'jobpro'
  const [sortDir1, setSortDir1] = useState('asc');
  const onSort1 = (key) => {
    setSortKey1((prev) => {
      if (prev === key) {
        setSortDir1((d) => (d === 'asc' ? 'desc' : 'asc'));
        return prev;
      } else {
        setSortDir1('asc');
        return key;
      }
    });
  };
  const sortedRecords1 = useMemo(() => {
    if (!sortKey1) return filteredRecords;
    const arr = [...filteredRecords];
    arr.sort((a, b) => {
      const va = (a?.[sortKey1] ?? '').toString().toLowerCase();
      const vb = (b?.[sortKey1] ?? '').toString().toLowerCase();
      if (va < vb) return sortDir1 === 'asc' ? -1 : 1;
      if (va > vb) return sortDir1 === 'asc' ? 1 : -1;
      return 0;
    });
    return arr;
  }, [filteredRecords, sortKey1, sortDir1]);


  const visibleIds = useMemo(
    () => filteredRecords.map((r) => toId(r.jobid)),
    [filteredRecords]
  );
  const allSelected =
    visibleIds.length > 0 &&
    visibleIds.every((id) => selectedRows.includes(id));
  const toggleSelectAll = (checked) => {
    setSelectedRows((prev) => {
      if (checked) return Array.from(new Set([...prev, ...visibleIds]));
      const toRemove = new Set(visibleIds);
      return prev.filter((id) => !toRemove.has(id));
    });
  };

  const onFilterChange = (key, value) =>
    setFilters((prev) => ({ ...prev, [key]: value }));
  const clearFilters = () =>
    setFilters({
      jobid: "",
      status: "",
      user: "",
      type: "",
      project: "",
      notes: "",
      proname: "",
      proport: "",
      ou: "",
      lob: "",
      comty: "",
      routeaerial: "",
      routeug: "",
      coaxae: "",
      coaxug: "",
      asbae: "",
      asbug: "",
      lode: "",
      hc: "",
    });

  // ====== GRID 2 ======
  const filteredRecords2 = useMemo(() => {
    const matchText = (value, needle) =>
      !needle || normalize(value).includes(normalize(needle));
    const matchEq = (value, needle) =>
      !needle || normalize(value) === normalize(needle);

    return (records || []).filter((r) => {
      const f = filters2;
      const js = String(r?.jobsta ?? "").trim().toLowerCase();
      // Grid 2 must show both: Ready for QC + Job Ready
      if (js !== "ready for qc" && js !== "job ready") return false;
      if (js === "invoicing" || js === "billed" || js === "not assigned" || js === "archived" ) return false;
      if (!matchText(r?.jobid, f.jobid)) return false;
      if (!matchEq(r?.jobsta, f.status)) return false;
      if (!matchEq(r?.jobuser, f.user)) return false;
      if (!matchEq(r?.jobti, f.type)) return false;
      if (!matchText(r?.jobpro, f.project)) return false;
      if (!matchText(r?.jobnotes, f.notes)) return false;

      if (!matchText(r?.jobproname, f.proname)) return false;
      if (!matchText(r?.jobproport, f.proport)) return false;
      if (!matchText(r?.jobou, f.ou)) return false;
      if (!matchText(r?.joblob, f.lob)) return false;
      if (!matchText(r?.jobcomty, f.comty)) return false;
      if (!matchText(r?.jobrouteaerial, f.routeaerial)) return false;
      if (!matchText(r?.jobrouteug, f.routeug)) return false;
      if (!matchText(r?.jobcoaxae, f.coaxae)) return false;
      if (!matchText(r?.jobcoaxug, f.coaxug)) return false;
      if (!matchText(r?.jobasbae, f.asbae)) return false;
      if (!matchText(r?.jobasbug, f.asbug)) return false;
      if (!matchText(r?.joblode, f.lode)) return false;
      if (!matchText(r?.jobhc, f.hc)) return false;
      return true;
    });
  }, [records, filters2]);

  const filteredRecords2Sorted = useMemo(() => {
    const arr = [...(filteredRecords2 || [])];
    const toTs = (v) => {
      if (!v) return 0;
      const d = new Date(v);
      if (!isNaN(d)) return d.getTime();
      const m = String(v).match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2}))?$/
      );
      if (!m) return 0;
      const [, Y, M, D, h = "00", i = "00", s = "00"] = m;
      return new Date(+Y, +M - 1, +D, +h, +i, +s).getTime();
    };
    arr.sort((a, b) => toTs(b?.jobdatesub) - toTs(a?.jobdatesub));
    return arr;
  }, [filteredRecords2]);
  // --- Sorting for Grid 2 (Status, User, Type, EP Status, Project) ---
  const [sortKey2, setSortKey2] = useState(null);
  const [sortDir2, setSortDir2] = useState('asc');
  const onSort2 = (key) => {
    setSortKey2((prev) => {
      if (prev === key) {
        setSortDir2((d) => (d === 'asc' ? 'desc' : 'asc'));
        return prev;
      } else {
        setSortDir2('asc');
        return key;
      }
    });
  };
  const sortedRecords2 = useMemo(() => {
    const base = filteredRecords2Sorted;
    if (!sortKey2) return base;
    const arr = [...base];
    arr.sort((a, b) => {
      const va = (a?.[sortKey2] ?? '').toString().toLowerCase();
      const vb = (b?.[sortKey2] ?? '').toString().toLowerCase();
      if (va < vb) return sortDir2 === 'asc' ? -1 : 1;
      if (va > vb) return sortDir2 === 'asc' ? 1 : -1;
      return 0;
    });
    return arr;
  }, [filteredRecords2Sorted, sortKey2, sortDir2]);


  const onFilterChange2 = (key, value) =>
    setFilters2((prev) => ({ ...prev, [key]: value }));
  const clearFilters2 = () =>
    setFilters2({
      jobid: "",
      status: "",
      user: "",
      type: "",
      project: "",
      notes: "",
      proname: "",
      proport: "",
      ou: "",
      lob: "",
      comty: "",
      routeaerial: "",
      routeug: "",
      coaxae: "",
      coaxug: "",
      asbae: "",
      asbug: "",
      lode: "",
      hc: "",
    });

  // Campos editables (incluye OU/LOB en modal y el resto inline)
  const editableFields = new Set([
    "jobsta",    "jobnotes",
    "jobproname",
    "jobproport",
    "jobou",
    "joblob",
    "jobcomty",
    "jobrouteaerial",
    "jobrouteug",
    "jobcoaxae",
    "jobcoaxug",
    "jobasbae",
    "jobasbug",
    "joblode",
    "jobhc",
    "jbhrex",
  ]);

  
  // Campos numéricos con input sin control para evitar sobreescritura al digitar
  const numericFields = new Set([
    "jobrouteaerial","jobrouteug","jobcoaxae","jobcoaxug",
    "jobasbae","jobasbug","joblode","jobhc"
  ]);
const startEdit = (id, field, currentVal) => {
    if (!editableFields.has(field)) return;
    let initial = currentVal ?? "";
    if (field === "jobid" && isTempId(currentVal)) initial = "";
    setEditingCell({ id: toId(id), field });
    setEditValue(initial);
  };
  const cancelEdit = () => {
    setEditingCell(null);
    setEditValue("");
  };

  const persistFieldChange = async (jobid, field, value) => {
    const jid = String(jobid ?? "").trim();
    if (field === "jobsta") {
      // Solo cuando cambia STATUS permitimos historial
      const cleanValue = typeof value === "string" ? value.trim() : value;
      const payload = { jobid: jid, [field]: cleanValue, __no_history: 0 };
      const res = await postJSON("/update_project.php", payload);
      if (!res?.data || res.data.status !== "success") {
        throw new Error(res?.data?.message || "Respuesta no exitosa");
      }
      return true;
    } else {
      // Para cualquier otro campo, bloqueamos historial
      const payload = { jobid: jid, [field]: value };
      const res = await postWriteJSON("/update_project.php", payload);
      if (!res?.data || res.data.status !== "success") {
        throw new Error(res?.data?.message || "Respuesta no exitosa");
      }
      return true;
    }
  };const persistJobIdChange = async (oldId, newId) => {
    const res = await postWriteJSON("/update_jobid.php", {
      old_jobid: String(oldId ?? "").trim(),
      new_jobid: String(newId ?? "").trim(),
    });
    if (!res?.data || res.data.status !== "success") {
      throw new Error(res?.data?.message || "No se pudo actualizar el Job Id");
    }
    return true;
  };
  const persistCreateRecord = async (recordObj) => {
    const res = await postWriteJSON("/create_project.php", recordObj || {});
    if (!res?.data || res.data.status !== "success") {
      throw new Error(res?.data?.message || "Error al crear el registro");
    }
    return res.data.row || recordObj;
  };

  const commitEdit = async (valueOverride) => {
    if (committingRef.current) return; // guard contra doble disparo
    committingRef.current = true;
    const hasOverride =
      typeof valueOverride === "string" ||
      typeof valueOverride === "number" ||
      valueOverride === "";
    let nextValue = hasOverride ? String(valueOverride) : editValue;

    if (!editingCell) { committingRef.current = false; return; }
    const { id, field } = editingCell;
    if (field === "jbhrex") {
      try { nextValue = normalizeExtraHours(nextValue); }
      catch (err) { cancelEdit(); setTimeout(() => { committingRef.current = false; }, 250); alert(err.message); return; }
    }
    const currentRecord = records.find((r) => toId(r.jobid) === id) || {};
    const current = currentRecord?.[field] ?? "";

    if (String(current) === String(nextValue)) {
      cancelEdit();
      setTimeout(() => { committingRef.current = false; }, 250);
      return;
    }

    const prev = records;
    let next = records.map((r) =>
      toId(r.jobid) === id ? { ...r, [field]: nextValue } : r
    );
    setRecords(next);

    const wasTemp = isTempId(id);
    const newId = field === "jobid" ? String(nextValue).trim() : id;

    try {
      const recAfter =
        next.find((r) => toId(r.jobid) === newId) ||
        next.find((r) => toId(r.jobid) === id);

      // Si NO está persistido y no estamos editando el jobid y el jobid ya no es temporal → CREATE primero
            // Si el JobID era temporal y lo acabamos de cambiar a uno real, crear de inmediato
      if (wasTemp && field === "jobid" && !isTempId(newId)) {
        const jid = toId(newId);
        if (creatingRef.current.has(jid)) {
          const list = pendingUpdatesRef.current.get(jid) || [];
          // no hay update adicional aquí, pero mantenemos la estructura por consistencia
          pendingUpdatesRef.current.set(jid, list);
          cancelEdit();
          setTimeout(() => { committingRef.current = false; }, 250);
          return;
        }
        creatingRef.current.add(jid);
        try {
          const created = await persistCreateRecord({
            jobid: newId || "",
            jobdatesub: recAfter.jobdatesub || nowSql(),
            jobsta: recAfter.jobsta || "",
            jobuser: recAfter.jobuser || "",
            jobti: recAfter.jobti || "",
            jobclo: recAfter.jobclo || "",
            jobpro: recAfter.jobpro || "",
            jobnotes: recAfter.jobnotes || "",
            jobproname: recAfter.jobproname || "",
            jobproport: recAfter.jobproport || "",
            jobou: recAfter.jobou || "",
            joblob: recAfter.joblob || "",
            jobcomty: recAfter.jobcomty || "",
            jobrouteaerial: recAfter.jobrouteaerial || "",
            jobrouteug: recAfter.jobrouteug || "",
            jobcoaxae: recAfter.jobcoaxae || "",
            jobcoaxug: recAfter.jobcoaxug || "",
            jobasbae: recAfter.jobasbae || "",
            jobasbug: recAfter.jobasbug || "",
            joblode: recAfter.joblode || "",
            jobhc: recAfter.jobhc || "",
            jbhrex: recAfter.jbhrex ?? "0",
          });
          const stamped = { ...created, jobdatesub: created.jobdatesub || nowSql(), _localNew: false };
          next = next.map((r) => (toId(r.jobid) === toId(newId) || toId(r.jobid) === toId(id) ? { ...r, ...stamped } : r));
          setRecords(next);
          // Notificación QC si aplica
          try {
            const recForBump = next.find((r) => toId(r.jobid) === toId(newId)) || stamped;
            if (String(recForBump?.jobsta).trim().toLowerCase() === "ready for qc") {
              bumpQcAlert(recForBump.jobid, recForBump.jobpro, recForBump.jobuser);
            }
          } catch (e) {}
          // apply queued updates (en este flujo normalmente no hay)
          const queue = pendingUpdatesRef.current.get(jid) || [];
          for (const u of queue) { await persistFieldChange(jid, u.field, u.value); }
          pendingUpdatesRef.current.delete(jid);
          pushToast("Registro creado.", "success");
        } finally {
          creatingRef.current.delete(jid);
        }
      } else if (!isPersisted(recAfter) && field !== "jobid" && !isTempId(recAfter.jobid)) {
        const jid = toId(recAfter.jobid);

        // Si ya hay un CREATE en curso para este JobID, encolamos y salimos
        if (creatingRef.current.has(jid)) {
          const list = pendingUpdatesRef.current.get(jid) || [];
          list.push({ field, value: nextValue });
          pendingUpdatesRef.current.set(jid, list);
          pushToast("Cambios encolados mientras se crea el registro…", "info");
          cancelEdit();
          setTimeout(() => { committingRef.current = false; }, 250);
          return;
        }

        creatingRef.current.add(jid);
        try {
          const created = await persistCreateRecord({
            jobid: recAfter.jobid || "",
            jobdatesub: recAfter.jobdatesub || nowSql(),
            jobsta: recAfter.jobsta || "",
            jobuser: recAfter.jobuser || "",
            jobti: recAfter.jobti || "",
            jobclo: recAfter.jobclo || "",
            jobpro: recAfter.jobpro || "",
            jobnotes: recAfter.jobnotes || "",
            jobproname: recAfter.jobproname || "",
            jobproport: recAfter.jobproport || "",
            jobou: recAfter.jobou || "",
            joblob: recAfter.joblob || "",
            jobcomty: recAfter.jobcomty || "",
            jobrouteaerial: recAfter.jobrouteaerial || "",
            jobrouteug: recAfter.jobrouteug || "",
            jobcoaxae: recAfter.jobcoaxae || "",
            jobcoaxug: recAfter.jobcoaxug || "",
            jobasbae: recAfter.jobasbae || "",
            jobasbug: recAfter.jobasbug || "",
            joblode: recAfter.joblode || "",
            jobhc: recAfter.jobhc || "",
            jbhrex: recAfter.jbhrex ?? "0",
          });
          const stamped = { ...created, jobdatesub: created.jobdatesub || nowSql(), _localNew: false };
          next = next.map((r) => (toId(r.jobid) === toId(recAfter.jobid) ? { ...r, ...stamped } : r));
          setRecords(next);
          pushToast("Registro creado.", "success");
          try {
            const recForBump = next.find((r) => toId(r.jobid) === toId(recAfter.jobid)) || stamped;
            if (String(recForBump?.jobsta).trim().toLowerCase() === "ready for qc") {
              bumpQcAlert(recForBump.jobid, recForBump.jobpro, recForBump.jobuser);
            }
          } catch {}


          // Aplicamos actualizaciones que llegaron mientras se creaba
          const queue = pendingUpdatesRef.current.get(jid) || [];
          for (const u of queue) {
            await persistFieldChange(jid, u.field, u.value);
          }
          pendingUpdatesRef.current.delete(jid);
        } finally {
          creatingRef.current.delete(jid);
        }
      } else if (!wasTemp && field === "jobid") {
        await persistJobIdChange(id, newId);
        setRecords((curr) =>
          curr.map((r) =>
            toId(r.jobid) === newId ? { ...r, jobdatesub: nowSql() } : r
          )
        );
        pushToast("Job ID actualizado.", "success");
      } else if (!wasTemp && field !== "jobid") {
        await persistFieldChange(newId, field, nextValue);
        // If status transitioned to Ready for QC, bump localStorage counter
        if (field === "jobsta") {
          const wasReady = String(current).trim().toLowerCase() === "job ready";
          const isReady  = String(nextValue).trim().toLowerCase() === "job ready";
          if (!wasReady && isReady) {
            const recAfter2 = next.find((r) => toId(r.jobid) === newId) || currentRecord;
            bumpQcAlert(recAfter2?.jobid, recAfter2?.jobpro, recAfter2?.jobuser);
          }
        }
        setRecords((curr) =>
          curr.map((r) =>
            toId(r.jobid) === newId ? { ...r, jobdatesub: nowSql() } : r
          )
        );
        pushToast("Cambios guardados.", "success");
      } else {
        pushToast("Cambio aplicado (local).", "info");
      }
    } catch (err) {
      setRecords(prev);
      pushToast("Guardado local (sin conexión).", "info");
    } finally {
      cancelEdit();
      // liberar el guard luego de que termine el blur
      setTimeout(() => { committingRef.current = false; }, 250);
    }
  };

  const createNewLocalRecord = () => {
    if (isCreating) return;
    setIsCreating(true);
    try {
      const tempId = nextTempId();
      const me = getMyWorkId() || loggedUser; // Project por default = logueado
      const newRecord = {
        _localNew: true,
        jobid: tempId,
        jobsta: "",
        jobuser: "",
        jobti: "",
        jobclo: "",
        jobdatesub: nowSql(),   // autollenar Submission Date
        jobpro: me || "",
        jobnotes: "",
        jobproname: "",
        jobproport: "",
        jobou: "",
        joblob: "",
        jobcomty: "",
        jobrouteaerial: "",
        jobrouteug: "",
        jobcoaxae: "",
        jobcoaxug: "",
        jobasbae: "",
        jobasbug: "",
        joblode: "",
        jobhc: "",
        jbhrex: "0",
      };
      setRecords((prev) => [newRecord, ...prev]);
      pushToast("Fila temporal agregada (arriba).", "success");
    } finally {
      setIsCreating(false);
    }
  };

  function statusPillClass() {
    return "pill pill-status-green";
  }

  const projectPalette = {
    project01: { bg: "#F7D1B9", fg: "#5D2A0A" },
    project02: { bg: "#F4C6BC", fg: "#5D1A0A" },
    project03: { bg: "#EBD6FF", fg: "#4A2A6A" },
    project04: { bg: "#F2E5FF", fg: "#4A2A6A" },
    project05: { bg: "#DDF4ED", fg: "#0B4F4A" },
    project06: { bg: "#E3EEFF", fg: "#104A7A" },
    project07: { bg: "#EAF5D7", fg: "#3D5E0A" },
    project08: { bg: "#F5EEC0", fg: "#5D4B00" },
  };
  const projectStyle = (val) => {
    const k = normalize(val);
    const c = projectPalette[k];
    return c ? { background: c.bg, color: c.fg } : {};
  };

  /* =================== ICONOS =================== */
  const IconExcel = ({ className, size = 16 }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <rect width="16" height="16" rx="2" fill="#217346"/>
      <path d="M3.5 11l2.2-3-2.2-3h2l1.1 1.7L7.7 5h2l-2.2 3 2.2 3h-2l-1.1-1.7L5.5 11h-2z" fill="#fff"/>
    </svg>
  );

  // Burbujas pastel (botones)
  const IconBubble = ({ bg = "#cfeeff", size = 18, className, children }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill={bg} />
      {children}
    </svg>
  );

  const IconPlusBubble = (p) => (
    <IconBubble bg="#FFCC80" {...p}>
      <path d="M11 6h2v12h-2zM6 11h12v2H6z" fill="#fff" />
    </IconBubble>
  );
  const IconExportBubble = (p) => (
    <IconBubble bg="#C8E6C9" {...p}>
      <rect x="7" y="6" width="10" height="12" rx="2" fill="#fff" opacity="0.95" />
      <path d="M9 9h6M9 12h6M9 15h6" stroke="#C8E6C9" strokeWidth="1.6" />
    </IconBubble>
  );
  const IconUnfilterBubble = (p) => (
    <IconBubble bg="#D1C4E9" {...p}>
      <path d="M5 7h14l-5.5 5.5V18l-3-1v-4.5L5 7z" fill="#fff" />
    </IconBubble>
  );
  const IconBroomBubble = (p) => (
    <IconBubble bg="#B7D1FF" {...p}>
      <path d="M8 15l4-4 3 3-4 4H8v-3z" fill="#fff" />
      <rect x="13" y="7" width="2" height="6" transform="rotate(45 14 10)" fill="#fff" />
    </IconBubble>
  );
  const IconLogoutBubble = (p) => (
    <IconBubble bg="#FFAB91" {...p}>
      <rect x="6" y="6" width="7" height="12" rx="1.5" fill="#fff" />
      <path d="M13 12h5m0 0l-2-2m2 2l-2 2" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </IconBubble>
  );

  const IconLiveBubble = (p) => (
    <IconBubble bg="#CDB59E" {...p}>
      <path d="M10 8l6 4-6 4V8z" fill="#fff" />
    </IconBubble>
  );
  const IconArchivedBubble = (p) => (
    <IconBubble bg="#CDB59E" {...p}>
      <rect x="7" y="7" width="10" height="3" rx="1" fill="#fff" />
      <rect x="7" y="10" width="10" height="7" rx="1" fill="#fff" />
      <rect x="10" y="12" width="4" height="2" rx="0.5" fill="#CDB59E" />
    </IconBubble>
  );
  const IconAllBubble = (p) => (
    <IconBubble bg="#CDB59E" {...p}>
      <rect x="8" y="8" width="8" height="1.8" rx="0.9" fill="#fff" />
      <rect x="8" y="11" width="8" height="1.8" rx="0.9" fill="#fff" />
      <rect x="8" y="14" width="8" height="1.8" rx="0.9" fill="#fff" />
    </IconBubble>
  );

  /* =================== STYLES =================== */

  const topbar = (
    <div
      className="topbar d-flex align-items-center"
      style={{
        gap: 8, padding: "8px 10px",
        background: "var(--page-bg)", borderBottom: "1px solid #e5ded8",
        position: "relative"
      }}
    >
      <img
        src="/img/firma.png"
        alt="Sans Frontières Design"
        style={{ height: 61, objectFit: "contain" }}
        onError={(e) => (e.currentTarget.style.display = "none")}
      />

      {/* Título centrado */}
      <div
        style={{
          position: "absolute", left: "50%", transform: "translateX(-50%)",
          fontWeight: 600, letterSpacing: "0", color: "#2f2b26",
          fontFamily: '"Arial Narrow","HelveticaNeue-Condensed","Liberation Sans Narrow","PT Sans Narrow","Bahnschrift SemiCondensed","Bahnschrift","Arial",sans-serif',
          textTransform: "uppercase",
          background: "var(--page-bg)", padding: "3px 12px", borderRadius: 8,
          fontSize: 30
          
        }}
      >
        CONTROL PROJECTS
      </div>

      {/* Botones de vista */}
      <div className="ms-auto d-flex" style={{ gap: 8 }}>
        <button className={`btn btn-view ${viewMode === "live" ? "active" : ""}`} onClick={() => setViewMode("live")}>
          <IconLiveBubble className="me-1" /> Live Jobs
        </button>
        <button className={`btn btn-view ${viewMode === "archived" ? "active" : ""}`} onClick={() => setViewMode("archived")}>
          <IconArchivedBubble className="me-1" /> Archived
        </button>
        <button className={`btn btn-view ${viewMode === "all" ? "active" : ""}`} onClick={() => setViewMode("all")}>
          <IconAllBubble className="me-1" /> Show ALL
        </button>
      </div>
    </div>
  );

  return (
    <div
      className="container-fluid page-wrap"
      data-view={viewMode}
      style={{
        paddingLeft: 0,
        paddingRight: 0,
        height: "100vh",
        display: "grid",
        gridTemplateRows: "auto 1fr",
        gap: "8px",
      }}
    >
      {topbar}

      {/* ======= Global CSS ======= */}
      <style>{`
        :root{
          --page-bg: #f7f2ee;
          --grid-card-bg: #f4ede8;
          --th-color: #2f2b26;

          --row-selected-bg: #eaf6ee;
          --row-selected-bg-hover: #e2f3e7;
        }
        body{ background: var(--page-bg); }
        .page-wrap{ background: var(--page-bg); }

        .grid-card{
          display:flex; flex-direction:column;
          background: var(--grid-card-bg) !important;
          border-radius: 12px;
          position: relative;
          min-height: 0;
          overflow: hidden;            /* el scroll es interno en .grid-scroll */
          box-sizing: border-box;
        }
        .grid-scroll{
          position:relative; width:100%;
          overflow-y:auto; overflow-x:auto;
          min-height: 0;
        }

        /* Altura fija de las zonas scrolleables según la vista */
        .page-wrap[data-view="all"] .grid-scroll{
          height: 38vh;               /* dos grids: cada uno ~ medio alto */
        }
        .page-wrap[data-view="live"] .grid-scroll,
        .page-wrap[data-view="archived"] .grid-scroll{
          height: calc(100vh - 220px); /* un grid: ocupa casi todo, dejando topbar/botones */
        }

        table.grid-table{
          width:100%;
          min-width:1800px;
          text-align:center;
          vertical-align:middle;
          table-layout:fixed;
        }
        :root { --wide-col-w: 240px; }

:where(th[data-label="Project Name"], th[data-label="Project Port"], th[data-label="COM-Job type"], th[data-label="LOB"], th[data-label="Notes"]){
  width: var(--wide-col-w); min-width: var(--wide-col-w);
}
td.wide-col{ width: var(--wide-col-w); min-width: var(--wide-col-w); }
table.grid-table{ table-layout: fixed; }
td.clip-cell{ overflow:hidden !important; }
td.clip-cell .clip-flex{ display:flex; min-width:0; }
td.clip-cell .clip-text{ flex:1 1 auto; min-width:0; overflow:hidden !important; text-overflow:ellipsis !important; white-space:nowrap !important; }
td.clip-cell .clip-text *{ white-space:nowrap !important; max-width:100%; }

table.grid-table .extra-hours-col{ width:110px; min-width:110px; }
table.grid-table thead th{
  position: sticky; top: 0;
  z-index: 3;
  background: #efe7e3 !important;
  color: var(--th-color);
  font-weight:700;
  vertical-align: middle;
  white-space: nowrap;
}

/* Force header bg (fix checkbox/star cells) */
table.grid-table thead th, table.grid-table thead td{ background: #efe7e3 !important; }



        .pill{
          display:inline-block; padding:6px 12px;
          border-radius: 8px; font-size:13px; line-height:1; font-weight:700;
          border:1px solid rgba(0,0,0,0.06); user-select:none; white-space:nowrap;
        }
        .pill-cell{ display:flex; align-items:center; justify-content:center; min-height: 28px; width:100%; }
        .pill-cell .cell-empty{ margin: 0 auto; }
        .pill-status-green{ background:#E6F4EA; color:#195A2B; }
        .pill-user{ background:#e6efff; color:#0b3e91; }
        .pill-type{ background:#f4f0d6; color:#6d5c00; }
        .pill-project{ background:#d6ecff; color:#084b8a; }

        .cell-editable{ cursor:pointer; }
        .cell-editable:hover{ background:#fafafa; }
        .grid-table td{ padding: 9px 8px; vertical-align: middle; }
        .grid-table th{ padding: 12px 8px; }

        .filter-cell{ position:relative; }
        .filter-cell select{ width:100%; }
        .filter-input { position: relative; }
        .filter-input:has(.header-input:placeholder-shown):not(:hover):not(:focus-within)::after{
          content: attr(data-label);
          position: absolute;
          left: 12px; top: 50%; transform: translateY(-50%);
          pointer-events: none; color: var(--th-color); font-weight: 700;
        }
        .filter-input:has(.header-input:placeholder-shown):not(:hover):not(:focus-within) .header-input{
          color: transparent; -webkit-text-fill-color: transparent; caret-color: transparent;
        }

        .left-cell{ text-align:left; }
        .pill-td{ text-align:center; }


        td.sel-cell{ position:relative; }
        .row-index{ display:inline-block; min-width: 20px; opacity: 0.9; }
        .row-check{
          position:absolute; left:50%; top:50%; transform: translate(-50%, -50%);
          opacity:0; pointer-events:none; transition: opacity .15s ease;
        }
        td.sel-cell:hover .row-check{ opacity:1; pointer-events:auto; }
        td.sel-cell:hover .row-index{ opacity:0; }

        .fav-star{
          cursor:pointer;
          font-size:20px; line-height:1; color:#ff9800;
          transition: transform .12s ease, opacity .12s ease;
        }
        .fav-star.off{ opacity:.85; }
        .fav-star:hover{ transform: scale(1.1); }

        .grid-card .btn{
          font-size: .95rem;
          padding: .475rem .90rem;
        }

        .btn-add{
          background:#e86f00; border-color:#e86f00; color:#fff;
        }
        .btn-add:hover{ filter: brightness(.92); }
        .btn-add:disabled{ background:#e86f00 !important; border-color:#e86f00 !important; color:#fff !important; opacity:1 !important; filter:none !important; cursor:not-allowed; }
        .btn-solid-danger{ background:#f8d7da; border-color:#f5c2c7; color:#842029; }
        .btn-solid-danger:hover{ filter: brightness(.97); }
        .btn-solid-danger:disabled{ background:#f8d7da !important; border-color:#f5c2c7 !important; color:#842029 !important; opacity:1 !important; filter:none !important; cursor:not-allowed; }
        .btn-add .plus-icon{ color:#fff; font-weight:800; margin-right:6px; }

.btn-history{
  background:#696969; border-color:#FDF5E6; color:#FDF5E6;
  border-radius:6px;            /* mismas esquinas que los otros */
  padding:.475rem .90rem;         /* mismo alto/ancho visual */
}
.btn-history:hover{ filter:brightness(.95); }


        
        .cell-empty{ color:#9aa0a6; font-style: italic; }

        .cell-hotpriority{ background:#f6c9c9; border:1px solid #f0b3b3; color:#7a1f1f; border-radius:12px; padding:6px 10px; width:100%; box-sizing:border-box; }

        .grid-table tbody tr.row-selected td{ background: var(--row-selected-bg) !important; }
        .grid-table tbody tr.row-selected:hover td{ background: var(--row-selected-bg-hover) !important; }
        .grid-table tbody tr.row-selected td.sel-cell .row-check{ opacity: 1; pointer-events: auto; }
        .grid-table tbody tr.row-selected td.sel-cell .row-index{ opacity: 0; }

        .content-wrap{ min-height: 0; height: 100%; display: grid; gap: 8px; }

        /* 1 línea con … */
        .grid-table td, .grid-2-table td { position: relative; overflow: hidden; }
        .grid-table td > div, .grid-2-table td > div {
          display: block; width: 100%; max-width: 100%;
          overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
        }

        .btn-view{
          background:#d7c1a7; border-color:#d7c1a7; color:#4a2f21;
          font-size: 1.0rem; padding: .475rem .90rem;
        }
        .btn-view.active, .btn-view:hover{
          background:#caa987; border-color:#caa987; color:#3b2418;
        }

        .btn-solid-success{ background:#b9dfc7; color:#0e462c; border-color:#b9dfc7; }
        .btn-solid-secondary{ background:#c7d0db; color:#2f3a47; border-color:#c7d0db; }
        .btn-success-light{ background:#bfe8bf; color:#145a2b; border-color:#bfe8bf; }

        .btn svg { vertical-align: -2px; width: 1.1em; height: 1.1em; }

/* === Locked headers (same look, no interaction) === */
        .grid-table thead .form-control:disabled,
.grid-table thead .form-select:disabled{
  opacity: 1 !important;
  background-color: #efe7e3 !important;   /* match header background (no white) */
  filter: none !important;
  cursor: default !important;
  box-shadow: none !important;
}
        .grid-2-table thead .form-control:disabled,
.grid-2-table thead .form-select:disabled{
  opacity: 1 !important;
  background-color: #efe7e3 !important;   /* grid 2 header input bg */
  filter: none !important;
  cursor: default !important;
  box-shadow: none !important;
}
        .grid-2-table thead .form-control:disabled,
.grid-2-table thead .form-select:disabled{
  opacity: 1 !important;
  background-color: #efe7e3 !important;   /* grid 2 header input bg */
  filter: none !important;
  cursor: default !important;
  box-shadow: none !important;
}

/* === Encabezados select con etiqueta (Status/User/Type) === */
.filter-cell{ position:relative; }
.filter-cell select{ width:100%; }
.filter-cell.show-placeholder:not(:hover):not(:focus-within) select{
  color: transparent;               /* oculta "All" en reposo */
  -webkit-text-fill-color: transparent;
}
.filter-cell.show-placeholder:not(:hover):not(:focus-within)::after{
  content: attr(data-label);        /* muestra "Status", "User", "Type" */
  position:absolute; left:12px; top:50%; transform:translateY(-50%);
  pointer-events:none; color: var(--th-color, #2f2b26); font-weight:700;
}
.filter-cell.show-placeholder:hover::after,
.filter-cell.show-placeholder:focus-within::after{ content:""; }
.filter-cell select option{ color:#212529; }  /* opciones legibles */
/* === Locked header: keep placeholders hidden even when disabled (avoid overlap) === */
.filter-input:has(.header-input:placeholder-shown):not(:hover):not(:focus-within) .header-input:disabled{
  color: transparent !important;
  -webkit-text-fill-color: transparent !important;
  caret-color: transparent !important;
}
.filter-cell.show-placeholder:not(:hover):not(:focus-within) select:disabled{
  color: transparent !important;               /* oculta "All" en reposo */
  -webkit-text-fill-color: transparent !important;
}




      `}</style>

      <div
        className="content-wrap"
        style={{
          gridTemplateRows: viewMode === "all" ? "1fr 1fr" : "1fr",
        }}
      >
        {(viewMode === "all" || viewMode === "live") && (
          <div className="card shadow-sm p-4 grid-card">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0" style={{ color: "#2f2b26", fontWeight: 700 }}>
                <span className="badge bg-warning text-dark" style={{ marginRight: 8 }}>
                  LIVE JOBS
                </span>
                {loggedUser || "Project-??"}
              </h5>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-add"
                  onClick={createNewLocalRecord}
                  disabled={true}
                  title="Agregar fila temporal (arriba)"
                >
                  <span className="plus-icon">+</span> Add
                </button>

                <button
                  className="btn btn-solid-success"
                  onClick={() => exportToXLS(filteredRecords, favoriteRows)}
                  title="Exportar registros filtrados a Excel"
                >
                  <IconExcel className="me-1" /> Download
                </button>
{/* History */}
                     
          <button className="btn btn-history" onClick={() => navigate("/history-view")}>


  History
            </button>




                <button className="btn btn-solid-secondary" onClick={clearFilters}>
                  <span className="me-1">📎</span> Unfilter
                </button>

                {/* Unselect */}
                <button
                  className="btn btn-solid-danger"
                  disabled={true}
                  onClick={() => setSelectedRows([])}
                  title="Quitar selección"
                >
                  <span className="me-1">🧹</span> Remove
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() => {
                    clearLogged();
                    navigate("/");
                  }}
                >
                  <span className="me-1">🚪</span> Logout
                </button>
              </div>
            </div>

            <div className="grid-scroll">
              <Grid1Table />
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <small className="text-muted">
                {filteredRecords.length} registros · {selectedRows.length} seleccionados · {favoriteRows.length} favoritos
              </small>
            </div>
          </div>
        )}

        {(viewMode === "all" || viewMode === "archived") && (
          <div className="card shadow-sm p-4 grid-card">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0" style={{ color: "#2f2b26", fontWeight: 700 }}>
                <span className="badge bg-warning text-dark" style={{ marginRight: 8 }}>
                  ARCHIVED
                </span>
                Jobs Sent to USA
              </h5>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-success-light"
                  onClick={() => exportToXLS(filteredRecords2Sorted, favoriteRows2)}
                >
                  <IconExcel className="me-1" /> Download
                </button>
                <button className="btn btn-solid-secondary" onClick={clearFilters2}>
                  <span className="me-1">📎</span> Unfilter
                </button>
              </div>
            </div>

            <div className="grid-scroll">
              <style>{`
                .grid-2-table thead th, .grid-2-table thead td { background: #efe7e3 !important; }
                .grid-2-table thead .form-control, .grid-2-table thead .form-select { background-color: #efe7e3 !important; }
              `}</style>
              <Grid2Table />
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <small className="text-muted">
                {filteredRecords2Sorted.length} registros · {favoriteRows2.length} favoritos
              </small>
            </div>
          </div>
        )}
      </div>

      {/* Toasts */}
      <div style={{ position: "fixed", right: 16, bottom: 16, zIndex: 9999 }}>
        {toasts.map((t) => (
          <div
            key={t.id}
            className="shadow-sm mb-2 px-3 py-2 rounded text-white"
            style={{
              background:
                t.variant === "success"
                  ? "#2e7d32"
                  : "#6c757d",
            }}
          >
            {t.msg}
          </div>
        ))}
      </div>
    </div>
  );

  /* =================== SUB-COMPONENTES DE TABLAS =================== */

  function Grid1Table() {
    return (
      <table className="table table-bordered table-hover grid-table">
        <colgroup>
          <col style={{ width: "50px" }} />
          <col style={{ width: "50px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "120px" }} />
          <col style={{ width: "120px" }} />
          <col style={{ width: "170px" }} />
          {/* Submission Date */}
          <col style={{ width: "180px" }} />
          {/* Project */}
          <col style={{ width: "150px" }} />
          {/* Notes */}
          <col style={{ width: "150px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "250px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "110px" }} />
          <col style={{ width: "250px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "150px" }} />
        </colgroup>

        {/* Encabezado */}
        <thead><tr><th>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={(e) => { if (!DISABLE_GRID_HEADERS) toggleSelectAll(e.target.checked); }}
                style={DISABLE_GRID_HEADERS ? { pointerEvents: "none" } : undefined}
                title="Seleccionar visibles"
              />
            </th><th>
              <span title="Favoritos" style={{ fontSize: "18px" }}>
                ☆
              </span>
            </th><th className="filter-input" data-label="Job Id">
              <input
                className="form-control form-control-sm header-input"
                placeholder="Job Id"
                value={filters.jobid}
                onChange={(e) => onFilterChange("jobid", e.target.value)}
              disabled={DISABLE_GRID_HEADERS}
              />
            </th><th className="filter-cell show-placeholder" data-label="Status" onClick={() => { if (!DISABLE_GRID_HEADERS) onSort1("jobsta"); }}>
  <select className="form-select form-select-sm"
    value={filters.status}
    disabled={DISABLE_GRID_HEADERS}
    onChange={(e) => onFilterChange("status", e.target.value)}
   onMouseDown={(e) => { e.stopPropagation(); }} onClick={(e) => e.stopPropagation()}>
    <option value="">All</option>
    {statusOptions.map(s => (
      <option key={s} value={s}>{s}</option>
    ))}
  </select>
</th><th className="filter-cell show-placeholder" data-label="User" onClick={() => { if (!DISABLE_GRID_HEADERS) onSort1("jobuser"); }}>
  <select
    className="form-select form-select-sm"
    value={filters.user}
    disabled={DISABLE_GRID_HEADERS}
    onChange={(e)=>onFilterChange("user", e.target.value)}
   onMouseDown={(e) => { e.stopPropagation(); }} onClick={(e) => e.stopPropagation()}>
    <option value="">All</option>
    {userOptions.map(u => (
      <option key={u} value={u}>{u}</option>
    ))}
  </select>
</th><th className="filter-cell show-placeholder" data-label="Type" onClick={() => { if (!DISABLE_GRID_HEADERS) onSort1("jobti"); }}>
  <select
    className="form-select form-select-sm"
    value={filters.type}
    disabled={DISABLE_GRID_HEADERS}
    onChange={(e)=>onFilterChange("type", e.target.value)}
   onMouseDown={(e) => { e.stopPropagation(); }} onClick={(e) => e.stopPropagation()}>
    <option value="">All</option>
    {typeOptions.map(t => (
      <option key={t} value={t}>{t}</option>
    ))}
  </select>
</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Submission Date
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>Project</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>LOB</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              OU-Comcast
            </th><th className="filter-input" data-label="Notes">
              <input
                className="form-control form-control-sm header-input"
                placeholder="Notes"
                value={filters.notes}
                onChange={(e) => onFilterChange("notes", e.target.value)}
              disabled={DISABLE_GRID_HEADERS}
              />
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Route Aerial
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Route UG
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Coax AE
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Coax UG
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Asb AE
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Asb UG
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>Lode/Nodes</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>HC/Amps</th><th className="extra-hours-col" title="Horas extras ingresadas manualmente">Hr Extras</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Project Name
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Project Port
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>COM-Job type</th></tr></thead>

        {/* Body */}
        <tbody style={{ whiteSpace: "nowrap" }}>
          {sortedRecords1.map((r, idx) => {
            const id = toId(r.jobid);
            const isFav = favoriteRows.includes(id);
            const isSel = selectedRows.includes(id);
            const rowNumber = idx + 1;

            // Componente Cell (edición inline + modal grande)
            const Cell = ({ field, value, pill, selectOptions, area, editor }) => {
              const isEditing =
                editingCell &&
                editingCell.id === id &&
                editingCell.field === field;

              const editable = editableFields.has(field);
              const start = (e) => { if (!editable) return; if (pill && selectOptions && shouldOpenRef) { try { shouldOpenRef.current = true; } catch(e) {} } startEdit(id, field, value); };
              const onKey = (e) => {
                if (e.key === "Enter") commitEdit();
                if (e.key === "Escape") cancelEdit();
              };

              
              // Campos que deben abrir modal de texto grande (por si no se pasa "area")
            
 const isTextAreaModal = (
   area === "notes" || area === "proname" || area === "proport" || area === "ou" || area === "lob" || area === "comty" ||
   field === "jobnotes" || field === "jobproname" || field === "jobproport" || field === "jobou" || field === "joblob" || field === "jobcomty"
 );



/* clickStartIfEmpty eliminado: ya no se usa (1-click edit) */

              // ---- Hooks ----
              const areaRef = useRef(null);
              const inputRef = useRef(null);
              const selectRef = useRef(null);
              const shouldOpenRef = useRef(false);


              
  const anchorRectRef = useRef(null);
  const [ddShow, setDdShow] = useState(false);
  const [ddPos, setDdPos] = useState({top:0,left:0,width:220});
const [localValue, setLocalValue] = useState(editValue);
              useEffect(() => {
                if (isEditing && isTextAreaModal) {
                  setLocalValue(editValue ?? "");
                }
              // eslint-disable-next-line react-hooks/exhaustive-deps
              }, [isEditing, editValue, area]);

              useEffect(() => {
                if (!isEditing) return;
                if (isTextAreaModal) {
                  if (areaRef.current) {
                    const el = areaRef.current;
                    requestAnimationFrame(() => {
                      try {
                        const L = el.value.length;
                        el.setSelectionRange(L, L);
                      } catch {}
                    });
                  }
                } else {
                  if (inputRef.current && !numericFields.has(field)) { try { inputRef.current.select(); } catch {} }
                }
              // eslint-disable-next-line react-hooks/exhaustive-deps
              }, [isEditing, area]);

              

              // Auto-abrir el <select> al entrar en edición (1 click)
              useEffect(() => {
                if (isEditing && selectOptions && selectRef && selectRef.current) {
                  setTimeout(() => {
                    try { selectRef.current.focus(); } catch (e) {}
                    try { 
                      // Disparar apertura del desplegable
                      selectRef.current.click(); 
                      if (shouldOpenRef.current) {
                        const ev = new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window });
                        selectRef.current.dispatchEvent(ev);
                      }
                    } catch (e) {}
                    shouldOpenRef.current = false; // reset after trying to open
                  }, 0);
                }
              }, [isEditing, selectOptions]);
// === Edición como select
              if ((isEditing || ddShow) && selectOptions) {
      const isDropdownPill = pill === "status" || pill === "user" || pill === "type";
      const styleOverlay = ddShow && isDropdownPill
        ? { position: "fixed", zIndex: 10000, top: ddPos.top, left: ddPos.left, width: ddPos.width, background:"#fff", border:"1px solid #E4DFD7", borderRadius:12, padding:"6px", boxShadow:"0 12px 24px rgba(0,0,0,0.12)", outline:"none" }
        : undefined;
      const sizeAttr = ddShow && isDropdownPill ? Math.min(8, (selectOptions?.length || 0)) : undefined;
      const handleChange = (e) => { setEditValue(e.target.value); commitEdit(e.target.value); setDdShow(false); };
      const handleBlur = () => { if (ddShow && isDropdownPill) { setDdShow(false); cancelEdit(); } };
      return (
        <select
          ref={selectRef}
          autoFocus
          className="form-select form-select-sm"
          value={editValue ?? ""}
          size={sizeAttr}
          onMouseDown={(e) => { e.stopPropagation(); }}
          onChange={handleChange}
          onBlur={handleBlur}
          style={styleOverlay}
        >
          {!sizeAttr && <option value="">— Seleccionar —</option>}
          {selectOptions.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
        </select>
      );
    }


              // === Edición con MODAL (Notes / Project Name / Project Port / OU / LOB)
              if (isEditing && isTextAreaModal) {
                const stop = (e) => e.stopPropagation();

                const save = () => commitEdit(localValue);

                const escOrSave = (e) => {
                  if (e.key === "Escape") cancelEdit();
                  if ((e.ctrlKey || e.metaKey) && e.key === "Enter") save();
                };

                const titleMap = {
                  notes: "Editar Notes",
                  proname: "Editar Project Name",
                  proport: "Editar Project Port",
                  ou: "Editar OU",
                  lob: "Editar LOB",
                  comty: "Editar OU-Comcast",
                };
                const height = (area === "notes" || field === "jobnotes") ? "50vh" : "30vh";
                return (
                  <>
                    <div
                      onClick={cancelEdit}
                      style={{
                        position: "fixed", inset: 0, background: "rgba(0,0,0,.35)", zIndex: 9998
                      }}
                    />
                    <div
                      onClick={stop}
                      style={{
                        position: "fixed", zIndex: 9999,
                        left: "50%", top: "10vh", transform: "translateX(-50%)",
                        width: "min(900px, 90vw)", background: "#fff",
                        borderRadius: 12, boxShadow: "0 12px 28px rgba(0,0,0,.2)",
                        padding: 12
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>{titleMap[area] || "Editar"}</strong>
                        <button className="btn btn-sm btn-outline-secondary" onClick={cancelEdit}>×</button>
                      </div>

                      <textarea
                        ref={areaRef}
                        autoFocus
                        className="form-control"
                        style={{ height }}
                        value={localValue}
                        onChange={(e) => setLocalValue(e.target.value)}
                        onKeyDown={escOrSave}
                        placeholder="Escribe aquí…  (Ctrl+Enter para guardar)"
                      />

                      <div className="d-flex justify-content-end gap-2 mt-2">
                        <button className="btn btn-secondary btn-sm" onClick={cancelEdit}>Cancelar</button>
                        <button className="btn btn-primary btn-sm" onClick={save}>Guardar</button>
                      </div>
                    </div>
                  </>
                );
              }

                  // Decimal text input accepts both separators without changing other editors.
                  if (isEditing && field === "jbhrex") {
                    return (
                      <input
                        ref={inputRef}
                        autoFocus
                        type="text"
                        inputMode="decimal"
                        className="form-control form-control-sm"
                        defaultValue={String(editValue ?? "")}
                        aria-label="Hr Extras"
                        title="Solo números no negativos; decimales con punto (.) o coma (,). Vacío equivale a 0."
                        onBlur={(e) => { if (e.currentTarget.dataset.cancelled !== "1") commitEdit(e.currentTarget.value); }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") { e.preventDefault(); e.currentTarget.blur(); }
                          if (e.key === "Escape") { e.preventDefault(); e.currentTarget.dataset.cancelled = "1"; cancelEdit(); }
                        }}
                      />
                    );
                  }

              // === Edición como input (JobID)
              if (isEditing && field === "jobid") {
                return (
                  <input
                    ref={inputRef}
                    autoFocus
                    className="form-control form-control-sm"
                    defaultValue={editValue}
                    onBlur={(e) => commitEdit(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") commitEdit(e.currentTarget.value);
                      if (e.key === "Escape") cancelEdit();
                    }}
                  />
                );
              }

              // Resto de campos: input controlado
              
              // === Edición: NUMÉRICOS (uncontrolled para evitar que la segunda tecla borre la primera)
              if (isEditing && numericFields.has(field)) {
                return (
                  <input
                    ref={inputRef}
                    autoFocus
                    className="form-control form-control-sm"
                    defaultValue={String(editValue ?? "")}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onBlur={(e) => commitEdit(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") commitEdit(e.currentTarget.value);
                      if (e.key === "Escape") cancelEdit();
                    }}
                  />
                );
              }
if (isEditing) {
                return (
                  <input
                    ref={inputRef}
                    autoFocus
                    className="form-control form-control-sm"
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    onBlur={commitEdit}
                    onKeyDown={onKey}
                  />
                );
              }

              // === Visualización
              const classForPill =
                pill === "status"
                  ? statusPillClass(value)
                  : pill === "user"
                  ? "pill pill-user"
                  : pill === "type"
                  ? "pill pill-type"
                  : pill === "project"
                  ? "pill pill-project"
                  : null;

              let display = value ?? "";
                  if (field === "jbhrex") display = formatExtraHours(value);

              // HOT Priority: mostrar aviso en Notes con fondo rojo pastel (pero sigue editable)
              const isHotPriority =
                field === "jobnotes" &&
                String(r?.jobclo || "").trim().toLowerCase() === "hot priority";
              if (isHotPriority) {
                const hotDisplay = "HOT Priority";
                return (
                  <div
                    className={`${editable ? "cell-editable " : ""}cell-hotpriority`}
                    onMouseDown={(e) => {
                      if (!editable) return;
                      e.preventDefault();
                      shouldOpenRef.current = true;
                      start();
                    }}
                    onClick={(e) => e.stopPropagation()}
                    title={hotDisplay}
                  >
                    {hotDisplay}
                  </div>
                );
              }
              if (editor === "date") display = formatDateTime(value);
              const isEmpty =
                display === "" || display === null || display === undefined;

              if (classForPill) {
                const extraStyle =
                  pill === "project" ? projectStyle(value) : undefined;
                return (
                  <div
                    className={`${editable ? "cell-editable " : ""}pill-cell`}
                    onMouseDown={(e)=>{ if(!editable) return; e.stopPropagation(); try { const r = e.currentTarget.getBoundingClientRect(); anchorRectRef.current = r; const width = Math.max(r.width, 220); const left = Math.min(r.left, window.innerWidth - width - 8); const top = Math.min(r.bottom + 4, window.innerHeight - 8); setDdPos({top,left,width}); setDdShow(true);} catch(_) {} start(e); }} onClick={(e) => e.stopPropagation()}
                    title={isEmpty ? "" : String(display)}
                  >
                    {isEmpty ? (
                      <span className="cell-empty">-</span>
                    ) : (
                      <span className={classForPill} style={extraStyle}>
                        {display}
                      </span>
                    )}
                  </div>
                );
              }

              return (
                <div
                  className={editable ? "cell-editable" : undefined}
                  onMouseDown={(e)=>{ if(!editable) return; e.preventDefault(); shouldOpenRef.current = true; start(); }} onClick={(e) => e.stopPropagation()}
                  title={isEmpty ? "" : String(display)}
                >
                  {isEmpty ? <span className="cell-empty">-</span> : display}
                </div>
              );
            };

            return (
              <tr
                key={id}
                className={isSel ? "row-selected" : ""}
                style={{ backgroundColor: "#fdf7f2" }}
              ><td className="sel-cell">
                  <span className="row-index">{rowNumber}</span>
                  <input
                    type="checkbox"
                    className="row-check"
                    checked={isSel}
                    onChange={(e) => handleCheckboxChange(e, id)}
                    title={`Seleccionar fila ${rowNumber}`}
                  />
                </td><td>
                  <span
                    className={`fav-star ${isFav ? "on" : "off"}`}
                    onClick={() => toggleFavorite(id)}
                    title={isFav ? "Quitar de favoritos" : "Marcar como favorito"}
                    role="button"
                    aria-label={isFav ? "Quitar de favoritos" : "Marcar como favorito"}
                  >
                    {isFav ? "★" : "☆"}
                  </span>
                </td><td className="left-cell">
                  <Cell field="jobid" value={r.jobid} />
                </td><td className="pill-td">
                  <Cell
                    field="jobsta"
                    value={r.jobsta}
                    pill="status"
                    selectOptions={statusOptionsClean}
                  />
                </td><td className="pill-td">
                  <Cell
                    field="jobuser"
                    value={r.jobuser}
                    pill="user"
                    selectOptions={userOptions}
                  />
                </td><td className="pill-td">
                  <Cell
                    field="jobti"
                    value={r.jobti}
                    pill="type"
                    selectOptions={typeOptions}
                  />
                </td><td>
                  <Cell field="jobdatesub" value={r.jobdatesub} editor="date" />
                </td><td className="pill-td">
                  <Cell
                    field="jobpro"
                    value={r.jobpro}
                    pill="project"
                    selectOptions={projectOptions}
                  />
                </td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="joblob" value={r.joblob} area="lob" /></div></div></td><td>
                <Cell field="jobcomty" value={r.jobcomty} area="comty" />
                </td><td className="left-cell wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobnotes" value={r.jobnotes} area="notes" /></div></div></td><td>
                  <Cell field="jobrouteaerial" value={r.jobrouteaerial} />
                </td><td>
                  <Cell field="jobrouteug" value={r.jobrouteug} />
                </td><td>
                  <Cell field="jobcoaxae" value={r.jobcoaxae} />
                </td><td>
                  <Cell field="jobcoaxug" value={r.jobcoaxug} />
                </td><td>
                  <Cell field="jobasbae" value={r.jobasbae} />
                </td><td>
                  <Cell field="jobasbug" value={r.jobasbug} />
                </td><td>
                  <Cell field="joblode" value={r.joblode} />
                </td><td>
                  <Cell field="jobhc" value={r.jobhc} />
                </td><td className="extra-hours-col"><Cell field="jbhrex" value={r.jbhrex} /></td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobproname" value={r.jobproname} area="proname" /></div></div></td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobproport" value={r.jobproport} area="proport" /></div></div></td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobou" value={r.jobou} area="ou" /></div></div></td></tr>
            );
          })}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan={23} style={{ textAlign: "left", background: "#f7f8fd" }}>
              <small className="ms-2 text-muted">
                Las filas con <em>JobID nuevo-#</em> son temporales; al cambiar el Job Id por uno real, se guardan en el servidor cuando edites otro campo.
              </small>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }

  function Grid2Table() {
    return (
      <table
        className="table table-bordered table-hover grid-table grid-2-table"
        style={{ "--bs-table-bg": "#e9f7ef", "--bs-table-striped-bg": "#e2f3ea" }}
      >
        <colgroup>
          <col style={{ width: "50px" }} />
          <col style={{ width: "50px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "120px" }} />
          <col style={{ width: "120px" }} />
          <col style={{ width: "170px" }} />
        {/* Submission Date */}
          <col style={{ width: "180px" }} />
        {/* Project */}
          <col style={{ width: "150px" }} />
        {/* Notes */}
          <col style={{ width: "150px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "250px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "100px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "110px" }} />
          <col style={{ width: "250px" }} />
          <col style={{ width: "150px" }} />
          <col style={{ width: "150px" }} />
        </colgroup>

        {/* Encabezado */}
        <thead><tr><th>
              <input
                type="checkbox"
                checked={false}
                onChange={() => {}}
                disabled
                title="Seleccionar visibles"
              />
            </th><th>
              <span title="Favoritos" style={{ fontSize: "18px" }}>
                ☆
              </span>
            </th><th className="filter-input" data-label="Job Id">
              <input
                className="form-control form-control-sm header-input"
                style={{ backgroundColor: "#f2f3f5" }}
                placeholder="Job Id"
                value={filters2.jobid}
                onChange={(e) => onFilterChange2("jobid", e.target.value)}
              disabled={DISABLE_GRID_HEADERS}
              />
            </th><th className="filter-cell show-placeholder" data-label="Status" onClick={() => { if (!DISABLE_GRID_HEADERS) onSort2("jobsta"); }}>
              <select
                className="form-select form-select-sm"
                style={{ backgroundColor: "#f2f3f5" }}
                value={filters2.status}
    disabled={DISABLE_GRID_HEADERS}
                onChange={(e) => onFilterChange2("status", e.target.value)}
   onClick={(e) => e.stopPropagation()}>
                <option value="">All</option>
                {statusOptionsClean
                  .map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
              </select>
            </th><th className="filter-cell show-placeholder" data-label="User" onClick={() => { if (!DISABLE_GRID_HEADERS) onSort2("jobuser"); }}>
              <select
                className="form-select form-select-sm"
                style={{ backgroundColor: "#f2f3f5" }}
                value={filters2.user}
    disabled={DISABLE_GRID_HEADERS}
                onChange={(e) => onFilterChange2("user", e.target.value)}
   onClick={(e) => e.stopPropagation()}>
                <option value="">All</option>
                {userOptions.map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </th><th className="filter-cell show-placeholder" data-label="Type" onClick={() => { if (!DISABLE_GRID_HEADERS) onSort2("jobti"); }}>
              <select
                className="form-select form-select-sm"
                style={{ backgroundColor: "#f2f3f5" }}
                value={filters2.type}
    disabled={DISABLE_GRID_HEADERS}
                onChange={(e) => onFilterChange2("type", e.target.value)}
   onClick={(e) => e.stopPropagation()}>
                <option value="">All</option>
                {typeOptions.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Submission Date
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>Project</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>LOB</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              OU-Comcast
            </th><th className="filter-input" data-label="Notes">
              <input
                className="form-control form-control-sm header-input"
                style={{ backgroundColor: "#efe7e3" }}
                placeholder="Notes"
                value={filters2.notes}
                onChange={(e) => onFilterChange2("notes", e.target.value)}
              disabled={DISABLE_GRID_HEADERS}
              />
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Route Aerial
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Route UG
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Coax AE
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Coax UG
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Asb AE
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Asb UG
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>LODE</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>HC</th><th className="extra-hours-col" title="Horas extras ingresadas manualmente">Hr Extras</th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Project Name
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>
              Project Port
            </th><th style={{ fontWeight: 700, color: "var(--th-color)" }}>COM-Job type</th></tr></thead>

        {/* Body */}
        <tbody style={{ whiteSpace: "nowrap" }}>
          {sortedRecords2.map((r, idx) => {
            const id = toId(r.jobid);
            const isFav = favoriteRows2.includes(id);
            const rowNumber = idx + 1;

            const Cell = ({ field, value, pill, selectOptions, area, editor }) => {
              const classForPill =
                pill === "status"
                  ? statusPillClass(value)
                  : pill === "user"
                  ? "pill pill-user"
                  : pill === "type"
                  ? "pill pill-type"
                  : pill === "project"
                  ? "pill pill-project"
                  : null;

              let display = value ?? "";
                  if (field === "jbhrex") display = formatExtraHours(value);

              // HOT Priority: mostrar aviso en Notes con fondo rojo pastel
              const isHotPriority =
                field === "jobnotes" &&
                String(r?.jobclo || "").trim().toLowerCase() === "hot priority";
              if (isHotPriority) {
                return (
                  <div className="cell-hotpriority" title="HOT Priority">
                    HOT Priority
                  </div>
                );
              }
              if (editor === "date") display = formatDateTime(value);
              const isEmpty =
                display === "" || display === null || display === undefined;

              if (classForPill) {
                let extraStyle = undefined;
                if (pill === "project") extraStyle = projectStyle(value);
                if (pill === "status")
                  extraStyle = { background: "#cfe9da", color: "#145a2b" };
                return (
                  <div title={isEmpty ? "" : String(display)}>
                    {isEmpty ? (
                      <span className="cell-empty">-</span>
                    ) : (
                      <span className={classForPill} style={extraStyle}>
                        {display}
                      </span>
                    )}
                  </div>
                );
              }

              return (
                <div title={isEmpty ? "" : String(display)}>
                  {isEmpty ? <span className="cell-empty">-</span> : display}
                </div>
              );
            };

            return (
              <tr key={id} style={{ backgroundColor: "#2e7d32" }}><td className="sel-cell">
                  <span className="row-index">{rowNumber}</span>
                  <input
                    type="checkbox"
                    className="row-check"
                    checked={false}
                    onChange={() => {}}
                    disabled
                    title={`Seleccionar fila ${rowNumber}`}
                  />
                </td><td>
                  <span
                    className={`fav-star ${isFav ? "on" : "off"}`}
                    style={{ pointerEvents: "none", opacity: 0.4 }}
                  >
                    {isFav ? "★" : "☆"}
                  </span>
                </td><td className="left-cell">
                  <Cell field="jobid" value={r.jobid} />
                </td><td className="pill-td">
                  <Cell
                    field="jobsta"
                    value={r.jobsta}
                    pill="status"
                    selectOptions={statusOptionsClean}
                  />
                </td><td className="pill-td">
                  <Cell
                    field="jobuser"
                    value={r.jobuser}
                    pill="user"
                    selectOptions={userOptions}
                  />
                </td><td className="pill-td">
                  <Cell
                    field="jobti"
                    value={r.jobti}
                    pill="type"
                    selectOptions={typeOptions}
                  />
                </td><td>
                  <Cell field="jobdatesub" value={r.jobdatesub} editor="date" />
                </td><td className="pill-td">
                  <Cell
                    field="jobpro"
                    value={r.jobpro}
                    pill="project"
                    selectOptions={projectOptions}
                  />
                </td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="joblob" value={r.joblob} area="lob" /></div></div></td><td>
                  <Cell field="jobcomty" value={r.jobcomty} />
                </td><td className="left-cell wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobnotes" value={r.jobnotes} area="notes" /></div></div></td><td>
                  <Cell field="jobrouteaerial" value={r.jobrouteaerial} />
                </td><td>
                  <Cell field="jobrouteug" value={r.jobrouteug} />
                </td><td>
                  <Cell field="jobcoaxae" value={r.jobcoaxae} />
                </td><td>
                  <Cell field="jobcoaxug" value={r.jobcoaxug} />
                </td><td>
                  <Cell field="jobasbae" value={r.jobasbae} />
                </td><td>
                  <Cell field="jobasbug" value={r.jobasbug} />
                </td><td>
                  <Cell field="joblode" value={r.joblode} />
                </td><td>
                  <Cell field="jobhc" value={r.jobhc} />
                </td><td className="extra-hours-col"><Cell field="jbhrex" value={r.jbhrex} /></td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobproname" value={r.jobproname} area="proname" /></div></div></td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobproport" value={r.jobproport} area="proport" /></div></div></td><td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobou" value={r.jobou} area="ou" /></div></div></td></tr>
            );
          })}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan={23} style={{ textAlign: "left", background: "#f7f8fd" }}>
              <small className="ms-2 text-muted">
                Archivos listos para QC. Exporta o filtra según necesites.
              </small>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  }

  /* =================== EXPORT XLS (compartido) =================== */

  function exportToXLS(_rows, _favs) {
    try {
      // Usa SIEMPRE ambas tablas del DrafterGridPage (Live + Archived)
      const liveRows = Array.isArray(filteredRecords) ? filteredRecords : [];
      const archRows = Array.isArray(filteredRecords2Sorted) ? filteredRecords2Sorted : [];
      const allRows = [...liveRows, ...archRows];

      const norm = (v) => String(v ?? "").trim();
      const toNum = (v) => {
        if (v === null || v === undefined) return 0;
        const s = String(v).trim();
        if (!s || s === "-" ) return 0;
        const n = Number(s);
        return Number.isFinite(n) ? n : 0;
      };
      const to2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

      const escapeXml = (s) =>
        String(s ?? "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&apos;");

      const cell = (value, type = "String", styleId = "sText") =>
        `<Cell ss:StyleID="${styleId}"><Data ss:Type="${type}">${escapeXml(value)}</Data></Cell>`;

      const numCell = (n, styleId = "sNum2") =>
        `<Cell ss:StyleID="${styleId}"><Data ss:Type="Number">${escapeXml(String(to2(n)))}</Data></Cell>`;

      // ====== Headers (incluye toda la info visible en DrafterGridPage) ======
      const headersBase = [
        "#",
        "Fav",
        "Job Id",
        "Status",
        "User",
        "Type",
        "Submission Date",
        "Project",
        "LOB",
        "OU-Comcast",
        "Notes",
        "Route Aerial",
        "Route UG",
        "Total Route",
        "Coax AE",
        "Coax UG",
        "Total Coax",
        "Asb AE",
        "Asb UG",
        "Total Asb",
        "Lode/Nodes",
        "HC/Amps",
        "Project Name",
        "Project Port",
        "COM Job Type",
      ];

      const headersMainSFD = [
        ...headersBase,
        "Total Strand",          // AC
        "Total Strand > 2000",   // AD
        "Total Strand > 20000",  // AE
        "Total Design",          // AF
        "Total Design > 2000",   // AG
        "Lode",                  // AH
        "Lode > 2000",           // AI
        "Asbuilt",               // AJ
        "Asbuilt > 2000",        // AK
        "TOTAL",                 // AL
      ];

      const headersBentleySFD = [...headersBase, "TOTAL"]; // AC

      // ====== Calculadoras reutilizables ======
      const calcMainSFD = ({ totalRoute, totalCoax, totalAsb, lode }) => {
        let AC = totalRoute > 0 ? 10 : 0;
        let AD = totalRoute > 2000 ? ((totalRoute - 2000) / 5280) * 12.5 : 0;
        let AE = 0;

        let AF = totalCoax > 0 ? 12.5 : 0;
        let AG = totalCoax > 2000 ? ((totalCoax - 2000) / 5280) * 15.5 : 0;

        let AH = lode > 0 ? 8.5 : 0;
        let AI = lode > 2000 ? ((lode - 2000) / 5280) * 12.5 : 0;

        let AJ = totalAsb > 0 ? 8.5 : 0;
        let AK = totalAsb > 2000 ? ((totalAsb - 2000) / 5280) * 10 : 0;

        if (totalRoute > 20000) {
          AC = 0;
          AD = 0;
          AE = totalRoute * 0.008;
        }

        const AL = AC + AD + AE + AF + AG + AH + AI + AJ + AK;

        return {
          AC: to2(AC),
          AD: to2(AD),
          AE: to2(AE),
          AF: to2(AF),
          AG: to2(AG),
          AH: to2(AH),
          AI: to2(AI),
          AJ: to2(AJ),
          AK: to2(AK),
          AL: to2(AL),
        };
      };

      const calcBentleySFD = ({ project, lode, hc }) => {
        const p = norm(project);
        const W = lode; // LODE
        const Xraw = norm(hc);

        if (!W) return 0;

        const xIsZeroish = Xraw === "" || Xraw === "-" || toNum(Xraw) === 0;
        const X = toNum(Xraw);

        const tier = () => {
          if (xIsZeroish) return 15;
          if (X <= 14) return 30;
          if (X <= 24) return 45;
          return 60;
        };

        if (p === "Project-02" || p === "Project-03") {
          if (W === 2) return 60;
          if (W === 1) return tier();
          return 0;
        }

        // Otros proyectos: W >= 1
        if (W >= 1) return tier();
        return 0;
      };

      // ====== Construcción de filas ======
      const getBaseRow = (r, idx, isFav) => {
        const routeA = toNum(r?.jobrouteaerial);
        const routeU = toNum(r?.jobrouteug);
        const totalRoute = routeA + routeU;

        const coaxAE = toNum(r?.jobcoaxae);
        const coaxUG = toNum(r?.jobcoaxug);
        const totalCoax = coaxAE + coaxUG;

        const asbAE = toNum(r?.jobasbae);
        const asbUG = toNum(r?.jobasbug);
        const totalAsb = asbAE + asbUG;

        const lode = toNum(r?.joblode);
        const hc = r?.jobhc;

        return {
          idx: idx + 1,
          fav: isFav ? "★" : "",
          jobid: r?.jobid ?? "",
          status: r?.jobsta ?? "",
          user: r?.jobuser ?? "",
          type: r?.jobti ?? "",
          sub: r?.jobdatesub ?? "",
          project: r?.jobpro ?? "",
          lob: r?.joblob ?? "",
          ou: r?.jobou ?? "",
          notes: r?.jobnotes ?? "",
          routeA,
          routeU,
          totalRoute,
          coaxAE,
          coaxUG,
          totalCoax,
          asbAE,
          asbUG,
          totalAsb,
          lode,
          hc,
          projectName: r?.jobproname ?? "",
          projectPort: r?.jobproport ?? "",
          comJobType: r?.jobcomjobtype ?? r?.jobcomtype ?? r?.jobcom ?? "",
        };
      };

      const isCoaxBentley = (t) => norm(t).toLowerCase() === "coax bentley" || norm(t).toLowerCase() === "coaxbentley";

      // favoritos (si existen en tu lógica actual)
      const favSet1 = new Set((favoriteRows || []).map((x) => x?.jobid).filter(Boolean));
      const favSet2 = new Set((favoriteRows2 || []).map((x) => x?.jobid).filter(Boolean));
      const isFav = (r) => favSet1.has(r?.jobid) || favSet2.has(r?.jobid);

      const rowsMain = [];
      const rowsBentley = [];

      allRows.forEach((r, i) => {
        const baseR = getBaseRow(r, i, isFav(r));
        if (isCoaxBentley(baseR.type)) rowsBentley.push(baseR);
        else rowsMain.push(baseR);
      });

      // Ordena por Type (como estándar), luego Job Id
      const sortByType = (a, b) => {
        const ta = norm(a.type).toLowerCase();
        const tb = norm(b.type).toLowerCase();
        if (ta < tb) return -1;
        if (ta > tb) return 1;
        return norm(a.jobid).localeCompare(norm(b.jobid));
      };
      rowsMain.sort(sortByType);
      rowsBentley.sort(sortByType);

      // ====== XML Spreadsheet (multi-sheet) ======
      const headerRowXml = (headers) =>
        `<Row ss:AutoFitHeight="0" ss:Height="15">${headers
          .map((h) => cell(h, "String", "sHead"))
          .join("")}</Row>`;

      const baseCellsXml = (r) => [
        cell(r.idx, "Number", "sText"),
        cell(r.fav, "String", "sText"),
        cell(r.jobid),
        cell(r.status),
        cell(r.user),
        cell(r.type),
        cell(r.sub),
        cell(r.project),
        cell(r.lob),
        cell(r.ou),
        cell(r.notes),
        numCell(r.routeA),
        numCell(r.routeU),
        numCell(r.totalRoute),
        numCell(r.coaxAE),
        numCell(r.coaxUG),
        numCell(r.totalCoax),
        numCell(r.asbAE),
        numCell(r.asbUG),
        numCell(r.totalAsb),
        numCell(r.lode),
        cell(r.hc),
        cell(r.projectName),
        cell(r.projectPort),
        cell(r.comJobType),
      ].join("");

      // Draft-SFD (Main-SFD logic)
      let totalAL = 0;
      const mainRowsXml =
        rowsMain
          .map((r) => {
            const calc = calcMainSFD({
              totalRoute: r.totalRoute,
              totalCoax: r.totalCoax,
              totalAsb: r.totalAsb,
              lode: r.lode,
            });
            totalAL += calc.AL;

            return `<Row ss:AutoFitHeight="0" ss:Height="15">` +
              baseCellsXml(r) +
              numCell(calc.AC) +
              numCell(calc.AD) +
              numCell(calc.AE) +
              numCell(calc.AF) +
              numCell(calc.AG) +
              numCell(calc.AH) +
              numCell(calc.AI) +
              numCell(calc.AJ) +
              numCell(calc.AK) +
              numCell(calc.AL, "sNum2Bold") +
              `</Row>`;
          })
          .join("") +
        // total row
        (() => {
          const blankCount = headersBase.length - 1; // deja 1 celda para "TOTAL"
          const blanks = Array.from({ length: blankCount }, () => cell("", "String", "sText")).join("");
          return `<Row ss:AutoFitHeight="0" ss:Height="15">` +
            cell("TOTAL", "String", "sHead") +
            blanks +
            cell("", "String", "sText") + // AC
            cell("", "String", "sText") + // AD
            cell("", "String", "sText") + // AE
            cell("", "String", "sText") + // AF
            cell("", "String", "sText") + // AG
            cell("", "String", "sText") + // AH
            cell("", "String", "sText") + // AI
            cell("", "String", "sText") + // AJ
            cell("", "String", "sText") + // AK
            numCell(to2(totalAL), "sNum2Bold") +
            `</Row>`;
        })();

      // Draft Bentley-SFD (Coax Bentley-SFD logic)
      let totalBentley = 0;
      const bentleyRowsXml =
        rowsBentley
          .map((r) => {
            const total = calcBentleySFD({
              project: r.project,
              lode: r.lode,
              hc: r.hc,
            });
            totalBentley += total;

            return `<Row ss:AutoFitHeight="0" ss:Height="15">` +
              baseCellsXml(r) +
              numCell(total, "sNum2Bold") +
              `</Row>`;
          })
          .join("") +
        (() => {
          const blankCount = headersBase.length - 1;
          const blanks = Array.from({ length: blankCount }, () => cell("", "String", "sText")).join("");
          return `<Row ss:AutoFitHeight="0" ss:Height="15">` +
            cell("TOTAL", "String", "sHead") +
            blanks +
            numCell(to2(totalBentley), "sNum2Bold") +
            `</Row>`;
        })();

const worksheet = (name, headers, bodyRowsXml) => `
<Worksheet ss:Name="${escapeXml(name)}">
  <Table>
    ${headerRowXml(headers)}
    ${bodyRowsXml}
  </Table>
</Worksheet>`;


const workbook =
        `<?xml version="1.0"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:html="http://www.w3.org/TR/REC-html40">
<Styles>
  <Style ss:ID="sHead">
    <Alignment ss:Horizontal="Center" ss:Vertical="Center"/>
    <Font ss:Bold="1" ss:Color="#2f2b26"/>
    <Interior ss:Color="#efe7e3" ss:Pattern="Solid"/>
    <Borders>
      <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#d9d9d9"/>
      <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#d9d9d9"/>
      <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#d9d9d9"/>
      <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#d9d9d9"/>
    </Borders>
  </Style>
  <Style ss:ID="sText">
    <Alignment ss:Horizontal="Center" ss:Vertical="Center"/>
    <Borders>
      <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
    </Borders>
  </Style>
  <Style ss:ID="sNum2">
    <NumberFormat ss:Format="0.00"/>
    <Alignment ss:Horizontal="Center" ss:Vertical="Center"/>
    <Borders>
      <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
    </Borders>
  </Style>
  <Style ss:ID="sNum2Bold">
    <NumberFormat ss:Format="0.00"/>
    <Font ss:Bold="1"/>
    <Alignment ss:Horizontal="Center" ss:Vertical="Center"/>
    <Borders>
      <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
      <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#e0e0e0"/>
    </Borders>
  </Style>
</Styles>
${worksheet("Draft-SFD", headersMainSFD, mainRowsXml)}
${worksheet("Draft Bentley-SFD", headersBentleySFD, bentleyRowsXml)}
</Workbook>`;

      const blob = new Blob([workbook], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Draft_Report_SFD.xls";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("exportToXLS error:", e);
      alert("Error al generar el reporte.");
    }
  }
}
